import * as React from "react";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function ThumbsUpIcon(props: SvgIconProps) {
	return (
		<SvgIcon {...props} viewBox="0 0 20 20">
			<path
				d="M3.60733 9.24548H1.3038C0.583864 9.24548 0.000244141 9.82663 0.000244141 10.5435V18.698C0.000244141 19.4149 0.583864 19.9961 1.3038 19.9961H3.60733C4.32727 19.9961 4.91089 19.4149 4.91089 18.698V10.5435C4.91089 9.82663 4.32727 9.24548 3.60733 9.24548Z"
				fill={props.fill}
			/>
			<path
				d="M18.6389 14.4238C18.7139 13.9543 19.4925 13.4707 19.5496 12.8946C19.6068 12.3113 18.9175 11.7886 18.9175 11.1733C18.9175 10.5474 19.5961 10.0816 19.5461 9.4521C19.5175 9.06802 18.5854 7.79488 18.3675 7.79488H12.8319C12.7247 5.87449 14.4319 4.83251 14.1926 2.73431C14.089 1.82747 13.414 0.38718 12.4819 0.113348C10.1141 -0.587236 10.7533 2.12264 10.0426 3.77274C9.64978 4.68315 6.79625 8.05804 5.93555 9.30984C6.09269 9.60146 6.18197 9.93575 6.18197 10.2914V18.958C6.18197 19.0896 6.16769 19.2212 6.14269 19.3456C8.54265 20.0533 16.0997 20.2738 16.9747 19.5697C17.7318 18.9615 17.264 17.9871 17.5532 17.475C17.6925 17.2296 18.6389 17.1905 18.8568 16.4366C19.0854 15.6507 18.5532 14.975 18.6425 14.4238H18.6389Z"
				fill={props.fill}
			/>
		</SvgIcon>
	);
}
